import axios from 'axios';
import { DateTime } from 'luxon';
import md5 from 'md5';
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { setStimaGlobale, setStimeMinime } from '../features/StimeSlice';
import '../style/Stime.scss'
import HeaderBack from '../components/FaiDaTe/_HeaderBack';
import { ReactComponent as Less } from '../assets/new-icons/minus.svg';
import { ReactComponent as More } from '../assets/new-icons/plus.svg';
import { useNavigate } from 'react-router-dom';
import Switch from '@mui/material/Switch';
import ConfermaBTN from '../components/ConfermaBTN/ConfermaBTN';


function Stime() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const customerId = useSelector((user) => user.user.info.customer_id);
    const token = md5(customerId + DateTime.now().toFormat('y-MM-dd') + 'ApPeNrIcA')
    const stimeMinime = useSelector((user) => user.stime.stimeMinime)
    const [globalValue, setGlobalValue] = useState()
    const [globalMonthValues, setGlobalMonthValues] = useState([])
    const [step, setStep] = useState(0)
    const [set, setSwitch] = useState(false)
    const [valoreMin, setValMin] = useState()

    useEffect(() => {
        init()
    },[])

    const init = async () => {
        const getStime = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getStime.php?customer_id=${customerId}`;
        const { data } = await axios.get(getStime)
        dispatch(setStimeMinime(data.stime_minime))
        const arrayValues = data.stime_minime.map((r) => r.consumo)
        setGlobalMonthValues(arrayValues);
        dispatch(setStimaGlobale(Math.max.apply(Math, arrayValues)))
        setGlobalValue(Math.max.apply(Math, arrayValues))
    }

   
    const saveStime = async () => {
        const arrayMonths = '&mese[]=1&mese[]=2&mese[]=3&mese[]=4&mese[]=5&mese[]=6&mese[]=7&mese[]=8&mese[]=9&mese[]=10&mese[]=11&mese[]=12'
        const monthValues = set ? globalMonthValues : Array(12).fill(globalValue)
        const arrayValue = monthValues.map(v => `&valore[]=${v}`).join('')
        
        const setStima = `https://my.revoluce.it/area_utente/gestione/api/customers/setStime.php?customer_id=${customerId}&token=${token}${arrayMonths}${arrayValue}`
        const { data } = await axios.get(setStima)
        if(data.status){
            navigate('/enrica/richiesta-inoltrata')
        } else {
            alert('Abbiamo riscontrato un errore, riprova o contatta il nostro servizio clienti.')
        }
    }

    const decreaseMonthValue = (index) => {
        if (stimeMinime[index].consumo < globalMonthValues[index]) {
            globalMonthValues[index]--
            setGlobalMonthValues([...globalMonthValues])
        }
    }

    const increaseMonthValue = (index) => {
        globalMonthValues[index]++
        setGlobalMonthValues([...globalMonthValues])
    }
    return (
        <div className="faiDaTe_component">
            <HeaderBack text="Fai da te" step={step} setStep={setStep}/>
            <div className="stime">
                <p className="title">Le tue stime</p>
                <p className="secondary">Visualizza o modifica le tue stime</p>
                <p className="para">Puoi personalizzare il consumo stimato per ogni mese dell’anno in base ai tuoi dati storici.</p>
                
                {/* {showInfo && (
                    <div className="para">
                        <p>Il consumo giornaliero della tua utenza è calcolato in base ai dati reali di consumo che il tuo distributore locale ci mette quotidianamente a disposizione.</p>
                        <p>Nel caso in cui il distributore non ci comunicasse tempestivamente i dati, il nostro potente algoritmo calcolerà il consumo giornaliero tenendo conto, nell'ordine, di:</p>
                        <ol>
                            <li>I consumi rilevati da te tramite autolettura;</li>
                            <li>Il consumo medio mensile (dallo storico che abbiamo nei nostri sistemi)</li>
                            <li>Il consumo medio annuo (dallo storico che abbiamo nei nostri sistemi)</li>
                        </ol>
                        <p>Puoi modificare in ogni momento il calcolo del consumo giornaliero, modificando a tuo piacimento i dati presenti nella tabella a destra.</p>
                        <p>Per ogni mese puoi scegliere di inserire un consumo maggiore o minore rispetto a quello da noi calcolato: a seconda del dato che inserirai il tuo consumo giornaliero stimato aumenterà o diminuirà automaticamente.</p>
                        <p>Ovviamente, il dato si stabilizzerà quando avremo a disposizione i dati reali da parte del distributore.</p>
                        <p>NB: Il minimo valore che puoi inserire nella tabella dei consumi stimati è minimo il 50% dalla tabella di sinistra (ad esempio, se per Gennaio è calcolato un consumo di 200 kWh, il minimo valore che potrai inserire è di 100 kWh.)</p>
                    </div>
                )} */}
                {/* <div className="modify">
                    {flip ? <p onClick={() => setFlip(!flip)}>Torna alle stime</p> : <p onClick={() => setFlip(!flip)}>Modifica stime <ArrowForwardIosIcon/></p>}
                </div>
                <ReactCardFlip isFlipped={flip} flipDirection="horizontal">
                    <div className="liste">
                        <div className="lista">
                            <table className="stimeTable">
                                <thead>
                                    <tr className="headerTable">
                                        <th className="date">Mese</th>
                                        <th className="consumo">
                                            <span>Consumo</span>
                                        </th>
                                        <th className="type">
                                            <span>Tipo</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {stime && (
                                        stime.map((r, i) => (
                                            <tr key={i}> 
                                                <td>
                                                    {DateTime.fromObject({month: r.mese}).toFormat('MMMM')}
                                                </td>
                                                <td className="consumo">
                                                    {r.consumo} kWh
                                                </td>
                                                <td className="type"> 
                                                    {r.tipo_consumo}
                                                </td>
                                            </tr> 
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="liste">
                        <div className="months">
                                {stimeMinime && stimeMinime.map((stima, i) => (
                                    <div className="month" key={i}>
                                        <p className='monthName'>
                                            {DateTime.fromObject({ month: stima.mese }).toFormat('MMMM')}
                                        </p>
                                        <div className="change">
                                            <span className="less" onClick={() => decreaseMonthValue(i)}><Less /></span>
                                            <input type="number" placeholder={`${globalMonthValues[i]} kWh`} />
                                            <span className="more" onClick={() => increaseMonthValue(i)}><More /></span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px'}}>
                            <button disabled={stimeMinime && globalMonthValues.some((v, i) => v < stimeMinime[i].consumo)} className="button" onClick={() => saveStima()}>{wait === 'loading' ? <HourglassEmptyIcon/> : wait === 'done' ? <DoneIcon/> : 'Salva'}</button>
                    </div>
                    </div>
                </ReactCardFlip> */}
                <div className="boxSwitch">
                    <div className="choise start">
                        <p className={`main ${set ? '' : 'off'}`}>Uguale</p>
                        <p className='secondary'>Per ogni mese</p>
                    </div>
                    <div className="switch">
                        <Switch onChange={() => setSwitch(!set)} />
                    </div>
                    <div className="choise end">
                        <p className={`main ${set ? 'on' : ''}`}>Diverso</p>
                        <p className='secondary'>Per ogni mese</p>
                    </div>
                </div>
                {set ? (
                    <>
                        <div className="single">
                            <div className="months">
                                {stimeMinime && stimeMinime.map((stima, i) => (
                                    <div className="month" key={i}>
                                        <p className='monthName'>
                                            {DateTime.fromObject({ month: stima.mese }).toFormat('MMMM')}
                                        </p>
                                        <div className="change">
                                            <span className="less" onClick={() => decreaseMonthValue(i)}><Less /></span>
                                            <input type="number" placeholder={`${globalMonthValues[i]} kWh`} />
                                            <span className="more" onClick={() => increaseMonthValue(i)}><More /></span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <ConfermaBTN text="Conferma modifica" confermTxt="Confermi la modifica per le stime?" customFunc={saveStime} url="none"/>
                    </>
                ) : (
                    <>
                        <div className="global">
                            <span className="less" onClick={() => valoreMin === globalValue ? null : setGlobalValue(globalValue - 1)}><Less /></span>
                            <input type="number" value={globalValue} placeholder='350 kWh' onChange={(e) => setGlobalValue(e.target.value)} />
                            <span className="more" onClick={() => setGlobalValue(globalValue + 1)}><More /></span>
                        </div>
                        <p className="label">Puoi diminuire il tuo consumo stimato fino alla metà della nostra previsione</p>
                        <ConfermaBTN text="Conferma modifica" confermTxt="Confermi la modifica per le stime?" customFunc={saveStime} url="none"/>
                    </>
                )}
            </div>
        </div>
    )
}

export default Stime
